import React, { useState } from 'react'
import { shallowEqual, useDispatch, useSelector } from 'react-redux'

import { selectIsUserAuthenticated } from 'features/auth/selectors'
import { selectLocaleDict } from 'features/locale/selectors'
import { hideFirstDepositNotify } from 'features/notifies/actions'
import { selectNotifies } from 'features/notifies/selectors'

import NotifyContainer from '../NotifyContainer/NotifyContainer'
import FirstDepositPolling from './FirstDepositPolling/FirstDepositPolling'

const FirstDepositNotify = () => {
  const dispatch = useDispatch()

  const isAuth = useSelector(selectIsUserAuthenticated, shallowEqual)
  const locale = useSelector(selectLocaleDict, shallowEqual).bonuses
  const { item, isShowed } = useSelector(selectNotifies, shallowEqual).firstDeposit

  const [isTemporarilyShowed, setIsTemporarilyShowed] = useState(false)

  const hideNotify = () => {
    dispatch(hideFirstDepositNotify())
  }

  const hideTemporarily = () => {
    setIsTemporarilyShowed(true)
    hideNotify()
  }

  return isAuth ? (
    <>
      {!isShowed && !item && !isTemporarilyShowed ? <FirstDepositPolling /> : null}
      {isShowed || (!item && !isShowed) || isTemporarilyShowed ? null : (
        <NotifyContainer
          title={locale.yourFirstDeposit}
          value={item?.amount as number}
          currency={item?.amountCurrency as string}
          callback={hideNotify}
          backgroundCallback={hideTemporarily}
        />
      )}
    </>
  ) : null
}

export default FirstDepositNotify
